import React, {lazy, useState} from 'react';
import classNames from 'classnames';
import useLanguage from "../../../hooks/useLanguage";
import {localizedContent} from "../../../utils";

const ClickableAnswer = ({answer, disabled = false, onClick}) => {

    const {language} = useLanguage();
    const [clicked, setClicked] = useState(false);

    const onButtonClick = () => {
        // setClicked(true);
        onClick(answer);
    };

    return (
        <button type="button" className={classNames({
            button: true,
            block: true,
            option: true,
            active: clicked
        })}
                onClick={onButtonClick} disabled={disabled}>
            {localizedContent(answer, language)}
        </button>
    );
};

export default ClickableAnswer;
